var COURSE_DASHBOARD_STORAGE_KEY = "ai_creator_course_dashboard";

export function saveCourseDashboard(payload) {
  var nextValue = normalizeDashboard(payload);
  localStorage.setItem(COURSE_DASHBOARD_STORAGE_KEY, JSON.stringify(nextValue));
  return nextValue;
}

export function readCourseDashboard() {
  var raw = localStorage.getItem(COURSE_DASHBOARD_STORAGE_KEY);

  if (!raw) {
    return createEmptyDashboard();
  }

  try {
    return normalizeDashboard(JSON.parse(raw));
  } catch (error) {
    clearCourseDashboard();
    return createEmptyDashboard();
  }
}

export function clearCourseDashboard() {
  localStorage.removeItem(COURSE_DASHBOARD_STORAGE_KEY);
}

export function createEmptyDashboard() {
  return {
    stats: null,
    featuredCourse: null,
    courses: []
  };
}

function normalizeDashboard(payload) {
  var source = payload && payload.data && typeof payload.data === "object"
    ? payload.data
    : (payload || {});
  return {
    stats: source.stats || null,
    featuredCourse: source.featuredCourse || null,
    courses: Array.isArray(source.courses) ? source.courses : []
  };
}
